import styled from 'styled-components'

export const StyledLi = styled.li`
    display:block;
    float:left;
    position:relative;
    margin:10px;
    line-height:42px;
    height:35px;
    font-family:'Roboto Condensed',sans-serif;
    font-size:18px;
    color:#8c8c8c;
    text-transform:uppercase;

    select{
        margin-left:10px;
        position:relative;
        top:-3px;
        background:#8c8c8c;
    }
   
`

export const SidebarItem = styled.li`
    width:100%;
    background:#2b2b2b;
    list-style-type:none;
    text-transform:uppercase;
    font-size:18px;
    font-family:'Roboto Condensed', sans-serif;
    padding:10px;
    box-sizing:border-box;

`

export const StyledInput = styled.input`
    padding:10px;
    box-sizing:border-box;
    border:0;
    background:#201f1f;
    width:100%;
    text-align:center;
    font-size:18px;
    color:white;
`

export const ExitButton = styled.button`
    background:none;
    border:none;
    position:absolute;
    top:-15px;
    right:0;
    cursor: pointer;
    width:60px;
    height:60px;

    &:after, &:before{
        width:1px;
        height:30px;
        background:#fff;
        content:"";
        position:absolute;
        top:15px;
        left:29px;
        display:block;
        transform:rotate(45deg);
    }
    &:after{
        transform:rotate(-45deg);
    }

`